/* eslint-disable func-names */
import * as Yup from 'yup';

export default Yup.object().shape({
  clientId: Yup.number()
    .required('SCHEMA_ERRORS.REQUIRED_FIELD')
    .typeError('SCHEMA_ERRORS.REQUIRED_FIELD'),
  invoices: Yup.array().test(
    'invoices',
    'SCHEMA_ERRORS.NEED_MINIMUM_ONE_CFDI',
    function(value) {
      const errors = [];
      if (value.length === 0) {
        errors.push(
          this.createError({
            path: 'invoices',
            message: 'SCHEMA_ERRORS.NEED_MINIMUM_ONE_CFDI'
          })
        );
      }
      for (let i = 0; i < value.length; i++) {
        if (!value[i]) {
          errors.push(
            this.createError({
              path: `invoices[${i}]`,
              message: 'SCHEMA_ERRORS.REQUIRED_FIELD'
            })
          );
        }
        if (value[i]?.amountIvaIncluded === 0) {
          errors.push(
            this.createError({
              path: `invoices[${i}]`,
              message: 'SCHEMA_ERRORS.VALUE_GREATER_THAN_ZERO'
            })
          );
        }

        if (value[i]?.amountToPay <= 0) {
          errors.push(
            this.createError({
              path: `invoices[${i}]`,
              message: 'SCHEMA_ERRORS.VALUE_GREATER_THAN_ZERO'
            })
          );
        }
        if (value[i]?.amountToPay > value[i]?.amountIvaIncluded) {
          errors.push(
            this.createError({
              path: `invoices[${i}]`,
              message:
                'SCHEMA_ERRORS.AMOUNT_TO_PAY_MUST_BE_LESS_THAN_OR_EQUAL_TO_AMOUNT_IVA_INCLUDED'
            })
          );
        }
      }

      if (errors.length > 0) {
        return new Yup.ValidationError(errors);
      }
      return true;
    }
  )
});
